import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination, Keyboard } from "swiper/modules"

// Gallery slider controller for spectacle photo galleries
export default class extends Controller {
  static values = {
    color: { type: String, default: "#E85A71" }
  }

  connect() {
    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination, Keyboard],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      keyboard: {
        enabled: true
      },
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev")
      },
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        clickable: true,
        bulletClass: "gallery-bullet",
        bulletActiveClass: "active",
        renderBullet: (index, className) => {
          return `<span class="${className}" data-color="${this.colorValue}"></span>`
        }
      },
      on: {
        slideChange: () => this.updateBulletColors()
      }
    })

    this.applyColorStyles()
    this.updateBulletColors()
  }

  updateBulletColors() {
    const bullets = this.element.querySelectorAll(".gallery-bullet")
    const color = this.colorValue

    bullets.forEach(bullet => {
      if (bullet.classList.contains("active")) {
        bullet.style.backgroundColor = color
      } else {
        bullet.style.backgroundColor = "rgba(255, 255, 255, 0.5)"
      }
    })
  }

  applyColorStyles() {
    const color = this.colorValue
    const style = document.createElement("style")
    style.textContent = `
      [data-controller="gallery"] .swiper-button-next,
      [data-controller="gallery"] .swiper-button-prev {
        color: ${color} !important;
      }
    `
    this.element.appendChild(style)
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
